export const addresses = {
  dotNounsArt: "0x932e948E0435D412696fc7D7c95645Fb09Ff03d1",
};
